import { render, staticRenderFns } from "./isDownload.vue?vue&type=template&id=1002b4d9&scoped=true"
import script from "./isDownload.vue?vue&type=script&lang=js"
export * from "./isDownload.vue?vue&type=script&lang=js"
import style0 from "./isDownload.vue?vue&type=style&index=0&id=1002b4d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1002b4d9",
  null
  
)

export default component.exports